/**
 * Tâche 1210 (Eric 2026-06-26) — Jeton de lecture vidéo, court et ciblé.
 *
 * Le lecteur demande un jeton lié à CETTE vidéo (lecture seule) avant de
 * charger le flux, au lieu de s'appuyer sur la session complète. L'URL rendue
 * est calculée UNE fois par vidéo : un `<video>` dont on change la source en
 * cours de chargement jette « AbortError: media was removed from the
 * document » et reste muet (leçon P1.10). On renvoie donc "" tant que le
 * jeton n'est pas là — l'appelant n'affiche le lecteur qu'ensuite.
 *
 * Repli : si l'émission du jeton échoue (réseau, droits), on retombe sur
 * l'URL sans jeton, qui reste servie par le cookie httpOnly same-origin. Une
 * mesure de sécurité ne doit jamais empêcher une vidéo de jouer.
 */
import { useEffect, useState } from "react";
import axios from "axios";

export default function useStreamToken({ videoId, api }) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    // `api` peut LÉGITIMEMENT être vide : sur le domaine client, `API_BASE`
    // vaut "" pour que les appels restent en même origine. Le tester comme une
    // configuration manquante laissait le lecteur bloqué sur « Préparation de
    // la lecture… » (constaté au navigateur).
    if (!videoId) {
      setUrl("");
      return undefined;
    }
    let cancelled = false;
    const plain = `${api}/api/videos/${videoId}/stream`;
    (async () => {
      try {
        const { data } = await axios.post(
          `${api}/api/videos/${videoId}/stream-token`,
          {},
          { withCredentials: true, timeout: 15000 },
        );
        if (cancelled) return;
        if (data?.token) {
          setUrl(`${plain}?vt=${encodeURIComponent(data.token)}`);
          return;
        }
        setUrl(plain);
      } catch (_) {
        if (!cancelled) setUrl(plain);
      }
    })();
    return () => { cancelled = true; };
  }, [videoId, api]);

  return url;
}
